import { DEFAULT_WAF_UNICODES } from '../global-config/config';

export interface IWAFConfig {
  restrictedCharsList: string[];
  restrictedUnicodesList: string[];
  isSessionConfigUpdated: boolean;
}

export const WafEncoderUtility = {
  /**
   * Sets list of restricted char and unicodes from session or default value
   * @param wafEncoderConfig Contains list of restricted chars, unicodes and a flag
   * @param restrictedUnicodes list of restricted unicodes
   */
  setWAFEncoderConfig: (
    wafEncoderConfig: IWAFConfig,
    restrictedUnicodes?: string,
  ): void => {
    let wafRestrictedUnicodes = '';

    // Since few APIs are called before Configuration API, so need to use deault waf unicodes
    // set flag to true once session is set so that values can be cached
    if (restrictedUnicodes) {
      wafEncoderConfig.isSessionConfigUpdated = true;
      wafRestrictedUnicodes = restrictedUnicodes;
    } else {
      wafRestrictedUnicodes = DEFAULT_WAF_UNICODES;
    }

    wafEncoderConfig.restrictedUnicodesList = wafRestrictedUnicodes
      .split(',')
      .map((code: string) => '\\' + code);

    // Retrieve restricted char list from unicodes(support for only unicodes of length 4)
    wafEncoderConfig.restrictedCharsList = wafRestrictedUnicodes
      .split(',')
      .map((unicode: string) =>
        unicode.replace(/u[\w]{4}/gi, (match: string) =>
          String.fromCharCode(parseInt(match.replace(/u/g, ''), 16)),
        ),
      );
  },

  /**
   * Converts charcters in string to equivalent unicode
   * @param value String to be converted
   * @param restrictedUnicodesList List of restricted unicodes
   * @param restrictedCharsList List of restricted characters
   * @returns Converted string
   */
  convertToUnicode: (
    value: string,
    restrictedUnicodesList: string[],
    restrictedCharsList: string[],
  ): string => {
    let convertedString = '';
    for (const char of value) {
      // Not using replace since some of the chars are reserved words in RegExp
      const index: number = restrictedCharsList.findIndex(
        (x: string): boolean => x === char,
      );
      let newChar: string = char;
      if (index !== -1) {
        newChar = restrictedUnicodesList[index];
      }
      convertedString += newChar;
    }
    return convertedString;
  },
};
